import { useMutation, useQueryClient } from "@tanstack/react-query";
import { RequestWorkTimeResponse, UpdateWorkTimeListRequest } from "@/types";
import { httpRequest } from "@/lib";

async function updateWorkTimeList(
  workTimeData: UpdateWorkTimeListRequest
): Promise<RequestWorkTimeResponse> {
  const request = workTimeData;

  const response = await httpRequest.put<RequestWorkTimeResponse>(
    `/update/workTimes`,
    request
  );
  return response.data;
}

export function useUpdateWorkTimeListMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateWorkTimeList,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["workTimes"] });
    },
  });
}
